module.exports = {
  // TODO: Need to find a solution that allows us to use '/' for production.
  publicPath: '/dashboard/',
  lintOnSave: false,
  runtimeCompiler: true,
  devServer: {
    // By setting this as our FQDN the requests to /sockjs-node (used for hot-reloading with live reload) will use this FQDN which allows us to use a nginx-https-proxy to forward the requests to the host ip.
    public: 'apps.' + process.env.DOMAIN
  },
};